import { SelectOptionType } from "types/select/SelectOptionType";
import * as yup from "yup";

export const DetalhesProcessoJudicialSchema = yup.object().shape({
  advogado: yup.string().nullable(),
  cartorio: yup.string().nullable(),
  uf: yup.mixed<SelectOptionType<any>>().nullable(),
  cidade: yup.mixed<SelectOptionType<any>>().nullable(),
});
